import { Button } from "ui/components/button";
import { PermissionGate } from "permissions/components/gate";
import HeaderPortal from "components/portal/header-portal";
import React from "react";
import { useCreatePerformanceReview } from "./mutations";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { eventBus } from "utils/eventBus";
import EmployeeInput from "components/employee/input";
import CreateItemButton from "components/buttons/create";

const PerformanceReviewInputSheet = ({ reviews }) => {
  const [selectedReviewers, setSelectedReviewers] = useState([]);

  const { quadId, employeeId } = useParams();
  const { mutate: createPerformanceReview } = useCreatePerformanceReview({
    onSuccess: () => {
      eventBus.emit(
        "refresh:list",
        `performance_reviewcoverage-performance-reviews-${employeeId}-${quadId}`,
      );
    },
  });

  const handleConfirm = () => {
    if (selectedReviewers.length > 0 && quadId && employeeId) {
      selectedReviewers.forEach((reviewer) => {
        createPerformanceReview({
          quadrimester: quadId,
          revieweeId: employeeId,
          reviewerId: reviewer.id,
        });
      });
    }
  };

  function renderFooter({ setOpen }) {
    return (
      <Button
        onClick={() => {
          handleConfirm();
          setSelectedReviewers([]);
          setOpen(false);
        }}
      >
        Assign Reviewers
      </Button>
    );
  }

  const filters = {
    id: {
      _nin:
        reviews?.length > 0
          ? [employeeId, ...reviews.map((item) => item.id)]
          : [employeeId],
    },
  };

  return (
    <>
      <HeaderPortal>
        <PermissionGate
          rule="create:*"
          collection="performance_review"
          showWhenDisabled={false}
        >
          <EmployeeInput
            multiselect={true}
            value={selectedReviewers}
            onChange={setSelectedReviewers}
            allowRemoval={true}
            footer={renderFooter}
            excludedEmployeeIds={[
              ...(reviews?.map((item) => item.reviewer.id) || []),
              ...selectedReviewers.map((emp) => emp.id),
            ]}
            filters={filters}
          >
            <CreateItemButton>Reviewer</CreateItemButton>
          </EmployeeInput>
        </PermissionGate>
      </HeaderPortal>
    </>
  );
};

export default PerformanceReviewInputSheet;
